import React from "react";
import ChatModeratorKit from '../../data/ChatModeratorKit'
import ModeratorMenuView from "./ModeratorMenuView";

const ModeratorMenu = ({ generateMessages, filter, setFilter, event, page, type, corporateSettings, urlParams }) => {



    function showOnlyHighlighted() {
        setFilter(!filter)
    }

    function downloadCSV() {
        ChatModeratorKit.downloadPublicMessageCSV({ event, page })
            .then(res => {
                const filename = res.headers['content-disposition'].split('=')[1]
                const file = new File([res.data], filename, { type: 'text/csv;charset=UTF-8' });
                const fileUrl = window.URL.createObjectURL(file);
                window.location.assign(fileUrl);
            })
    }

    function downloadCorporateAllChatCSV() {
        ChatModeratorKit.downloadCorporateAllChatMessagesCSV(urlParams)
            .then(res => {
                const filename = res.headers['content-disposition'].split('=')[1]
                const file = new File([res.data], filename, { type: 'text/csv;charset=UTF-8' });
                const fileUrl = window.URL.createObjectURL(file);
                window.location.assign(fileUrl);
            })
    }

    return <ModeratorMenuView 
                generateMessages={generateMessages} 
                showOnlyHighlighted={showOnlyHighlighted} 
                downloadCSV={downloadCSV} filter={filter} 
                type={type} 
                corporateSettings={corporateSettings}
                downloadCorporateAllChatCSV={downloadCorporateAllChatCSV}  
            />
}
export default ModeratorMenu;